exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*#smartwizard {*/\n  /*width: 500px;*/\n  /*height: 400px;*/\n  /*direction: rtl;*/\n  /*text-align: center;*/\n/*}*/\n.resetPasswordLink\n{\n  font-size: 0.8em;\n  color: #80a3a7;\n  text-align: right;\n}\n.loginifalreadyregistered\n{\n  width: 253px;\n  margin: auto;\n  padding-top: 5px;\n  margin-top: 46px;\n  border-top: solid 1px #eee;\n}\n.outlinebutton\n{\n  border:solid 1px rgba(249, 168, 37, 0.48)\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/login/login.style.css
// module id = 907
// module chunks = 3